require('./brokerStocksSellStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');
const { OKMessage } = require('commonsComponents/OKMessage');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
// @components
const BrokerStocksSellStep2ExAnteDetails = require('components/broker/brokerStocksSell/brokerStocksSellStep2ExAnteDetails/brokerStocksSellStep2ExAnteDetails');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @hconstants
const {
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    FIRST_STEP,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');
const { BROKER_STOCKS_BUY_ID } = require('constants/operationTypes');
const { SELL_STOCKS_SHOW_COST } = require('constants/flagBasedFeatures');

class BrokerStocksSellStep2 extends React.Component {

    componentDidMount() {
        const { immFlagBasedFeatures, getExAnteData, history } = this.props;
        if(immFlagBasedFeatures.get(SELL_STOCKS_SHOW_COST)) {
            getExAnteData(history);
        }
    }

    buildDisclaimerContent() {
        const {immFlagBasedFeatures} = this.props;
        return immFlagBasedFeatures.get(SELL_STOCKS_SHOW_COST) ? (
            <div>
                <p className="stocks-sell-step2__disclaimer-content">
                    <FormattedText value="broker-stocksSellStep2ExAnteDisclaimerText1" />
                </p>
                <p>
                    <FormattedText value="broker-stocksSellStep2ExAnteDisclaimerText2" />
                </p>
            </div>
        ) : (
            <div>{formatText("broker-stocksSellStep2DisclaimerText")}</div>
        );
    }

    buildDetails(){
        const {
            immFlagBasedFeatures,
            productFile,
            productCurrency,
            immStocksContracts,
            immStocksSell,
            companyName,
            immBrokerProductFile
        } = this.props;

        const selectedOptionValue = immStocksSell.getIn([
            "steps",
            FIRST_STEP,
            "selectedOptionValue",
        ]);
        const stockContract = immStocksContracts.find((contract) => {
            return contract.get("contactNumber") === selectedOptionValue;
        });
        const step1 = immStocksSell.get("steps").get(FIRST_STEP);

        const content = immFlagBasedFeatures.get(SELL_STOCKS_SHOW_COST) ? (
            <BrokerStocksSellStep2ExAnteDetails
                productCurrency={productCurrency}
                stockContract={stockContract}
                stockDescription={companyName}
                step1={step1}
                productFile={immBrokerProductFile}
                immStocksSell={immStocksSell}
            />
        ) : (
            <StocksBuySellSummary
                productName={formatText("broker-stockProductName")}
                productCurrency={productCurrency}
                stockContract={stockContract}
                stockDescription={companyName}
                step1={step1}
                modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
                productIso={productFile}
            />
        );

        return content;
    }

    render() {
        const {
            immStocksSell,
            immStocksContracts,
            immFlagBasedFeatures,
        } = this.props;
        const step1 = immStocksSell.get("steps").get(FIRST_STEP);
        const selectedOptionValue = immStocksSell.getIn([
            "steps",
            FIRST_STEP,
            "selectedOptionValue",
        ]);
        const stockContract = immStocksContracts.find((contract) => {
            return contract.get("contactNumber") === selectedOptionValue;
        });

        if (!stockContract) {
            return;
        }

        const contractNumber = stockContract.get("walletNumber");
        const productNumber = stockContract.get("productNumber");
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const titlesAmount = step1.get("titleQuantity");
        const operationParams = {
            bondsNumber: titlesAmount,
            chargeAccount: chargeAccount,
        };
        const operative = formatText("operatives-brokerStocksSell");

        const detailsSection = this.buildDetails();

        return (
            <div className="stocks-sell-step2">
                <header className="stocks-sell-step2__header">
                    <h2 className="stocks-sell-step2__header-title">
                        {formatText("broker-stocksSellStep2HeaderTitle")}
                    </h2>
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={operative}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    { !immFlagBasedFeatures.get(SELL_STOCKS_SHOW_COST) &&
                        <p className="stocks-sell-step2__header-text">
                            {formatText("broker-stocksSellStep2HeaderText")}
                        </p>
                    }
                </header>
                {detailsSection}
                <footer className="stocks-sell-step2__footer">
                    <div className="stocks-sell-step2__disclaimer">
                        <OKMessage
                            id="stocks-sell-step2-disclaimer"
                            type="informative"
                            visible={true}
                        >
                            {this.buildDisclaimerContent()}
                        </OKMessage>
                    </div>
                    <ContactCenterRender>
                        <ConfirmationScript
                            confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                        />
                    </ContactCenterRender>
                    <SignaturePattern
                        operationType={BROKER_STOCKS_BUY_ID}
                        operationParams={operationParams}
                    />
                </footer>
            </div>
        );
    }
}

BrokerStocksSellStep2.propTypes = {
    history: PropTypes.object.isRequired,
    immStocksSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    productCurrency: PropTypes.string,
    companyName: PropTypes.string.isRequired,
    productFile: PropTypes.object.isRequired,
    immBrokerProductFile: PropTypes.object.isRequired,
    getExAnteData: PropTypes.func.isRequired,
};

module.exports = withRouter(BrokerStocksSellStep2);
